/* istanbul ignore file */

export async function loadPolyfillsIfNeeded() {
  await loadArrayAtPolyfill();
}

async function loadArrayAtPolyfill() {
  if (!Array.prototype.at) {
    try {
      await import('core-js/actual/array/at');
      // eslint-disable-next-line no-console
      console.log('Array.at polyfill loaded');
    } catch (error) {
      console.error('Failed to load Array.at polyfill:', error);
    }
  }
}
